import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainMenu from "./MainMenu";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import Swal from "sweetalert2";

function Newprofile() {
    const [open, setOpen] = useState(true);

    // Auto collapse on mobile + auto expand on desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setOpen(false); // hide on mobile
            } else {
                setOpen(true); // show on desktop
            }
        };

        handleResize(); // run on load
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const initialForm = {
        id: "",
        regNo: "",
        name: "",
        sex: "",
        caste: "",
        age: "",
        height: "",
        star: "",
        dhosham: "",
        qualification: [""],
        job: "",
        native: "",
        phone: "",
        fee: "",
        mode: "",
        remarks: ""
    };

    const initialForm1 = {
        // id: "",
        // no: "",
        // regNo: "",
        name: "",
        phone: "",
        job: "",
        sex: "",
        caste: "",
        age: "",
        // height: "",
        // star: "",
        // dhosham: "",
        // qualification: [""],
        // native: "",
        // fee: "",
        // mode: "",
        // remarks: "",
        // date: ""
    };

    const [formData, setFormData] = useState(initialForm);
    const [records, setRecords] = useState([]);
    const [editId, setEditId] = useState(null);




    useEffect(() => {
        fetchRecords();
    }, []);

    const fetchRecords = async () => {
        // const res = await fetch("http://localhost/api/get.php");
        const res = await fetch("https://matrimony.cubixsystems.com/api/get.php");
        const data = await res.json();
        setRecords(data);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCancel = () => {
        setFormData(initialForm);
        setEditId(null);

        // fetch("http://localhost/api/getRegNo.php")
        // fetch("https://matrimony.cubixsystems.com/api/getRegNo.php")
        //     .then((res) => res.json())
        //     .then((data) => {
        //         setFormData((prev) => ({
        //             ...prev,
        //             regNo: data.regNo
        //         }));
        //     })
        //     .catch(err => console.error(err));

        fetchRecords();
    }

    // Qualification handlers
    const handleQualificationChange = (index, value) => {
        const updated = [...formData.qualification];
        updated[index] = value;
        setFormData({ ...formData, qualification: updated });
    };

    const addQualification = () => {
        setFormData({
            ...formData,
            qualification: [...formData.qualification, ""],
        });
    };

    const removeQualification = (index) => {
        const updated = formData.qualification.filter((_, i) => i !== index);
        setFormData({ ...formData, qualification: updated });
    };

    const navigate = useNavigate();

    const validateForm = () => {
         if (!formData.regNo) return "Name is mandatory";
        if (!formData.name) return "Name is mandatory";
        if (!formData.phone) return "Phone number is mandatory";
        if (!formData.age) return "Age is mandatory";
        if (!formData.height) return "Height is mandatory";
        if (!formData.sex) return "Gender is mandatory";
        if (!formData.caste) return "Caste is mandatory";
        if (!formData.star) return "Star is mandatory";
        if (!formData.dhosham) return "Dhosham is mandatory";
        if (!formData.job) return "Job is mandatory";
        if (!formData.native) return "Native place is mandatory";

        // Qualification check
        const hasEmptyQualification = formData.qualification.some(q => !q.trim());
        if (hasEmptyQualification) return "Qualification is mandatory";

        if (!formData.mode) return "Payment mode is mandatory";

        return null; // ✅ no errors
    };

    const handleSave = async () => {
        const error = validateForm();

        if (error) {
            Swal.fire({
                icon: "warning",
                title: "Matrimony Registration",
                text: error
            });
            return;
        }

        const payload = {
            ...formData,
            age: parseInt(formData.age),
            qualification: formData.qualification.join(", "),
        };

        console.log("Sending payload:", payload);

        const isEdit = !!editId;

        const url = isEdit
            ? "https://matrimony.cubixsystems.com/api/update.php"
            : "https://matrimony.cubixsystems.com/api/save.php";

        try {
            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",

                },
                body: JSON.stringify(payload),
            });


            console.log("Response status:", res.status);

            
            const text = await res.text();
            console.log("Raw response:", text);

            // Try parsing JSON
            let data;
            try {
                data = JSON.parse(text);
            } catch (err) {
                throw new Error("Invalid JSON response from server");
            }

            console.log("Parsed response:", data);

            if (data.status === "success" || data.status === "updated") {

                if (!isEdit) {
                    await Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Profile registered successfully!",
                        timer: 1500,
                        showConfirmButton: false
                    });

                    // Open print page
                    localStorage.setItem("printData", JSON.stringify(formData));
                    window.open("/print", "_blank");

                } else {
                    Swal.fire({
                        icon: "success",
                        title: "Updated",
                        text: "Profile updated successfully!"
                    });
                }

                // ✅ Reset form
                setFormData(initialForm);
                setEditId(null);

                // ✅ Refresh records
                await fetchRecords();

                // ✅ Refresh regNo
                // const regRes = await fetch("https://matrimony.cubixsystems.com/api/getRegNo.php", {
                //     headers: { "Cache-Control": "no-cache" }
                // });

                // const regData = await regRes.json();

                // setFormData(prev => ({
                //     ...prev,
                //     regNo: regData.regNo
                // }));

            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: data.msg || "Something went wrong"
                });
            }

        } catch (err) {
            // console.error("Fetch error:", err);

            // Swal.fire({
            //     icon: "error",
            //     title: "Connection Error",
            //     text: "Failed to connect to server. Check API / CORS / URL"
            // });
        }
    };

    // useEffect(() => {
    //     fetch("https://matrimony.cubixsystems.com/api/getRegNo.php")
    //         .then((res) => res.json())
    //         .then((data) => {
    //             console.log(data); // 

    //             setFormData((prev) => ({
    //                 ...prev,
    //                 regNo: data.regNo
    //             }));
    //         })
    //         .catch(err => console.error(err));
    // }, []);

    const handleEdit = (rec) => {
        setFormData({
            ...rec,
            qualification: rec.qualification
                ? rec.qualification.split(",")
                : [""],
        });
        setEditId(rec.id);
    };

    const handleDelete = async (id) => {

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This record will be permanently deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        });

        if (result.isConfirmed) {
            try {
                const res = await fetch(`https://matrimony.cubixsystems.com/api/delete.php?id=${id}`);
                const data = await res.json();

                if (data.status === "deleted") {
                    Swal.fire({
                        icon: "success",
                        title: "Deleted!",
                        text: "Record deleted successfully",
                        timer: 1500,
                        showConfirmButton: false
                    });

                    // Refresh data
                    fetchRecords();

                    // Refresh regNo
                    // fetch("https://matrimony.cubixsystems.com/api/getRegNo.php")
                    //     .then((res) => res.json())
                    //     .then((data) => {
                    //         setFormData((prev) => ({
                    //             ...prev,
                    //             regNo: data.regNo
                    //         }));
                    //     });

                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: data.msg || "Delete failed"
                    });
                }

            } catch (err) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Something went wrong"
                });
            }
        }
    };

    const [search, setSearch] = useState("");
    const filteredRecords = records.filter((rec) => {
        const searchText = search.toLowerCase();

        return (
            rec.name?.toLowerCase().includes(searchText) ||
            rec.phone?.toLowerCase().includes(searchText)
        );
    });

    const handlePrint = (rec) => {
        // store selected row data
        localStorage.setItem("printData", JSON.stringify(rec));

        // open print page in new tab
        window.open("/print", "_blank");
    };

    return (
        <div className="container-fluid p-0">
            <div
                className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
                style={{
                    zIndex: 999,
                    cursor: "pointer",
                    position: "fixed",
                    left: open ? "350px" : "60px",
                    top: "0",
                    transition: "left 0.3s ease"
                }}
                onClick={() => setOpen(!open)}
            >
                <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
                    ☰
                </span>
            </div>

            <div className="d-flex" style={{ height: "100vh" }}>

                {/* LEFT SIDEBAR */}
                <div
                    className="border-end leftcolor"
                    style={{
                        width: open ? "350px" : "0",
                        overflow: "hidden",
                        transition: "0.3s ease",

                    }}
                >
                    {open && (
                        <div className="p-3">
                            <AdminLeft />
                        </div>
                    )}
                </div>

                {/* RIGHT CONTENT */}
                <div
                    className="p-4"
                    style={{
                        width: open ? "calc(100% - 350px)" : "100%",
                        transition: "0.3s ease",
                        paddiingLeft: '10px'
                    }}
                >
                    <div>
                        <TopBanner />
                    </div>
                    <div className="" style={{ height: '100vh', overflow: 'auto' }}>
                        <div className="row">
                            <div className="col-md-3" style={{ background: 'lightyellow-', padding: '30px', borderRight: '1px groove silver' }}>

                                <h3 style={{ fontSize: '12pt', fontWeight: '600', borderBottom: '1px solid maroon', paddingBottom: '2px' }}>New Profile
                                    {/* <span style={{color:'maroon'}}>{formData.name}</span> */}
                                    <br />
                                    {/* <span style={{ fontWeight: '600', fontSize: '15pt', color: 'maroon' }}>{formData.regNo}</span> */}
                                </h3>
                                <table class="table-" style={{ width: '100%' }}>
                                    <tr>
                                        <td colspan="3">
                                            <input name="regNo" type="text" placeholder="Reg No" value={formData.regNo} onChange={handleChange} className="form-control" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input name="name" type="text" placeholder="Name" value={formData.name} onChange={handleChange} className="form-control" required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input name="phone" type="number" placeholder="Phone Number" value={formData.phone} onChange={handleChange} class="form-control" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            <input name="age" type="number" placeholder="Age" value={formData.age} onChange={handleChange} class="form-control" style={{ width: '10% !important' }} />
                                        </td>
                                        <td style={{ width: '15px !important' }}>
                                            <input name="height" type="text" placeholder="Height" value={formData.height} onChange={handleChange} class="form-control" style={{ width: '10% !important' }} />
                                        </td>
                                        <td style={{ width: '100px !important', display: 'flex', flexDirection: 'row' }}>
                                            {["Male", "Female"].map((s) => (
                                                <label key={s}>
                                                    <input
                                                        type="radio"
                                                        name="sex"
                                                        value={s}
                                                        checked={formData.sex === s}
                                                        onChange={handleChange}
                                                        style={{ marginLeft: '10px', marginRight: '6px' }} />
                                                    {s}
                                                </label>
                                            ))}
                                        </td>

                                    </tr>

                                    <tr>
                                        <td>
                                            <input name="caste" type="text" placeholder="Caste" value={formData.caste} onChange={handleChange} class="form-control" style={{ width: '10% !important' }} />
                                            {/* <select name="caste" value={formData.caste} onChange={handleChange} className="form-control black" style={{ width: '100%' }}>
                                                <option value="">Caste</option>
                                                <option>Nadar</option>
                                                <option>Nair</option>
                                                <option>Menon</option>
                                                <option>Brahmin</option>
                                            </select> */}
                                        </td>

                                        <td colspan="2">
                                            <select name="star" value={formData.star} onChange={handleChange} className="form-control black" style={{ width: '100%' }}>
                                                <option value=""> Star</option>
                                                {[
                                                    "Aswathy", "Bharani", "Karthika", "Rohini", "Makeeyram", "Thiruvathira", "Punartham","Pooyam","Aayilyam", "Makham","Pooram","Uthram","Atham","Chihira", "Chothi","Visaakam", "Anizham","Thrikketta","Moolam","Pooraadam","Uthraadam","Thiruvonam","Avittam","Chathayam","Pooruruttathi","Uthrattathi", "Revathi"
                                                ].map((s) => (
                                                    <option key={s}>{s}</option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input name="dhosham" type="text" placeholder="Enter Dhosham" value={formData.dhosham} onChange={handleChange} class="form-control" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input name="job" type="text" placeholder="Job" value={formData.job} onChange={handleChange} class="form-control" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input name="native" type="text" placeholder="Enter Place" value={formData.native} onChange={handleChange} class="form-control" />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td colspan="3">
                                            <div>
                                                {formData.qualification.map((q, i) => (
                                                    <div key={i}>
                                                        <div class="row">
                                                            <div class="col-md-8">
                                                                <input
                                                                    type="text"
                                                                    value={q}
                                                                    onChange={(e) => handleQualificationChange(i, e.target.value)}
                                                                    class="form-control" placeholder="Enter Qualification"
                                                                />
                                                            </div>
                                                            <div class="col-md-4">
                                                                <button class="btn btn-primary" onClick={addQualification} style={{ background: '#004962ff' }}>+</button>
                                                                {formData.qualification.length > 1 && (
                                                                    <button class="btn btn-secondary" onClick={() => removeQualification(i)}>-</button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <textarea placeholder="Remarks" name="remarks" value={formData.remarks} onChange={handleChange} class="form-control"></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <div class="col-md-12" style={{ color: 'black', marginTop: '20px', paddingBottom: '20px' }}>
                                                <h5 style={{ paddingBottom: '10px', borderBottom: '1px solid maroon', padding: '15px' }}>Registration Fee:
                                                    <span style={{ marginLeft: '5px', fontWeight: '600', color: 'maroon', marginBottom: '15px' }}>
                                                        Rs. 300
                                                        {/* <input name="fee" type="text" placeholder="Enter Fee" value={formData.fee} onChange={handleChange} class="form-control" style={{ fontSize: '12pt', fontWeight: '600', color: 'maroon' }} /> */}
                                                    </span>
                                                </h5>
                                                {["Cash", "UPI", "Debit/Credit Card"].map((m) => (
                                                    <label key={m}>
                                                        <input
                                                            type="radio"
                                                            name="mode"
                                                            value={m}
                                                            checked={formData.mode === m}
                                                            onChange={handleChange}
                                                            style={{ marginLeft: '10px', marginRight: '6px' }} />
                                                        {m}
                                                    </label>
                                                ))}
                                            </div>
                                            <button class="col-md-6 btn btn-warning" style={{}} onClick={handleSave}>{editId ? "Update" : "Register"}</button>
                                            <button class="col-md-6 btn btn-secondary" onClick={handleCancel}>Cancel</button>

                                        </td>
                                    </tr>


                                </table>



                            </div>
                            <div class="col-md-9" style={{ height: '80vh', overflow: 'auto', padding: '25px' }}>
                                <h4 style={{ fontWeight: '600' }}>Profiles</h4>
                                <input
                                    type="text"
                                    placeholder="Search by Name or Phone Number"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    style={{ marginBottom: "10px", padding: "5px", width: "300px" }}
                                />
                                <div classNmae="table-responsive">
                                    <table className="table" >
                                        <thead>
                                            <tr>
                                                <th>No</th> {/* 👈 Add this */}
                                                {Object.keys(initialForm1)
                                                    .filter((k) => k !== "id")
                                                    .map((k) => (
                                                        <th key={k}>{k.toUpperCase()}</th>
                                                    ))}
                                                <th>ACTIONS</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {filteredRecords.map((rec, index) => (
                                                <tr key={rec.id}>
                                                    <td>{index + 1}</td> {/* 👈 Serial Number */}

                                                    {Object.keys(initialForm1)
                                                        .filter((k) => k !== "id")
                                                        .map((k) => (
                                                            <td key={k}>{rec[k]}</td>
                                                        ))}

                                                    <td>
                                                        <button onClick={() => handleEdit(rec)} className=" btn-primary" style={{ padding: '6px', border: 'none', marginRight: '5px', background: 'white', color: 'maroon', border: '1px solid maroon', cursor: 'pointer' }} ><i class="fa fa-edit"></i></button>
                                                        <button onClick={() => handleDelete(rec.id)} className=" btn-danger" style={{ padding: '6px', border: 'none', marginRight: '5px', cursor: 'pointer' }}><i class="fa fa-trash"></i></button>
                                                        <button onClick={() => handlePrint(rec)} className=" btn-default" style={{ padding: '6px', border: 'none', cursor: 'pointer', border: '1px solid silver' }}><i class="fa fa-print"></i></button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="container">




            </div>

        </div>
    );
}


export default Newprofile;